import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import experimentFlags, { HOLIDAY_CARDS, PAPER_SECONDARY_NAV_REDESIGN } from 'util/experimentFlags';
import featureFlags from 'util/featureFlags';
import giftNavIcon from 'assets/images/navigation/gift.svg';
import type { MobileNavLink } from '../MobileNavMenuData';

const activeLinks: MobileNavLink[] = [
  { title: 'Your drafts + orders', path: '/wedding-planning/projects/drafts' },
  { title: 'Your favorites', path: '/favorites/paper' },
];

export default function getMobilePaperMenuData(userContext: UserContext): MobileNavLink[][] {
  const invitesLink = userContext?.is_guest
    ? '/wedding-planning/paper'
    : '/wedding-planning/universal';
  const isActiveInvitesUser = Boolean(userContext.invitation_account?.cards_onboarding_completed);
  const isSecondaryNavRedesign =
    featureFlags.get('secondaryNavRedesign') &&
    experimentFlags.isUnderTest(PAPER_SECONDARY_NAV_REDESIGN, userContext, false);
  const mobilePaperMenu = [
    ...insertInArrayIf(isActiveInvitesUser, activeLinks),
    [
      {
        title: isSecondaryNavRedesign ? 'Matching collections' : 'Matching suites',
        path: '/wedding-planning/suites/shop',
      },
      { title: 'Save the dates', path: '/wedding-planning/save-the-date/shop' },
      {
        title: isSecondaryNavRedesign ? 'Wedding invitations' : 'Invitations',
        path: '/wedding-planning/invitations/shop',
      },
      {
        title: isSecondaryNavRedesign ? 'Enclosures' : 'Enclosure cards',
        path: '/wedding-planning/enclosures/shop',
      },
      { title: 'Menus', path: '/wedding-planning/menus/shop' },
      { title: 'Place cards', path: '/wedding-planning/place-cards/shop' },
      {
        title: 'Table numbers',
        path: '/wedding-planning/table-numbers/shop',
      },
      { title: 'Programs', path: '/wedding-planning/programs/shop' },
      {
        title: isSecondaryNavRedesign ? 'Thank yous' : 'Thank you cards',
        path: '/wedding-planning/thank-you-cards/shop',
      },
      {
        title: isSecondaryNavRedesign ? 'Holiday' : 'Holiday cards',
        path: '/wedding-planning/holiday-cards/shop',
        icon: experimentFlags.getFlag(HOLIDAY_CARDS, userContext) ? giftNavIcon : null,
      },
      {
        title: 'Digital save the dates',
        path: '/wedding-planning/digital/save-the-date/shop',
      },
      {
        title: 'Shower invitations',
        path: '/wedding-planning/bridal-shower/shop',
      },
    ],
    [{ title: 'About invites & paper', path: invitesLink }],
  ];

  return mobilePaperMenu;
}
